// extracted by mini-css-extract-plugin
module.exports = {"payLaterInfo":"PayLaterInfo_payLaterInfo__dC_iy","payLaterIcon":"PayLaterInfo_payLaterIcon__aiPTl","learnMore":"PayLaterInfo_learnMore__UC6y_"};